import React, { useContext, useEffect, useState } from "react";
import { Tabs, LegacyCard as Card } from "@shopify/polaris";

// import helper
import { baseHelper } from "lib/helpers";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

import { SkeletonCard } from "lib/components";

// import context
import { PrivateContext } from "lib/context";

// import tab prop
import { tabProp } from "app/productLake/modules/generic/propTypes";
import { ProductProvider } from "app/productLake/modules/generic/context";

// import data
import editData from "app/productLake/modules/operator/features/edit/config/editData";

// import tab
import { useLocation, useNavigate } from "react-router-dom";
import EditInformation from "./information";
import EditImage from "./image";
import EditVariant from "./variant";
import EditInventory from "./inventory";
import EditFulfillment from "./fulfillment";
import EditAttachment from "./attachment";

const EditTabs = (props) => {
  const { setBanner, setDescription, setTitle, isVariant, isVariable, refetch, productValue } = props;
  const { cms, currentUser, isLoading } = useContext(PrivateContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAttachmentVisible = false } = currentUser || {};
  const { search } = location;
  const { tab } = baseHelper.getQueryParams(search);
  const { ATTACHMENT, FULFILLMENT, IMAGE, INFORMATION, INVENTORY, VARIANT } = constant;
  const [selected, setSelected] = useState("");
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [value, setValue] = useState({});
  const validProductTabs = editData(cms, isVariant, isAttachmentVisible, currentUser.ecommercePlatform, isVariable)
    .tabs;

  useEffect(() => {
    if (productValue) {
      setValue({
        ...productValue,
      });
    }
  }, [productValue]);

  useEffect(() => {
    const validtab = validProductTabs.map((item) => item.id);
    const tabName = validtab.includes(tab) ? tab : INFORMATION;
    setSelected(tabName);
    if (!validtab.includes(tab)) {
      baseHelper.setUrl(location, navigate, { tab: tabName });
    }
  }, [INFORMATION, location, navigate, selected, tab, validProductTabs]);

  useEffect(() => {
    let index = validProductTabs.findIndex((item) => item.id === tab);
    if (validProductTabs.length < index) {
      index = 0;
    }
    setSelectedTabIndex(index);
  }, [tab, validProductTabs]);

  if (isLoading) {
    return <SkeletonCard />;
  }

  const handleTabChange = (tabIndex) => {
    const tabId = validProductTabs[tabIndex].id;
    setSelected(tabId);
    baseHelper.setUrl(location, navigate, { tab: tabId });
  };

  const getTab = (tabSelected) => {
    let lastTab = isAttachmentVisible ? ATTACHMENT : FULFILLMENT;
    if (isVariant) {
      lastTab = isAttachmentVisible ? ATTACHMENT : VARIANT;
    }
    const tabObj = { islastTab: tabSelected === lastTab };

    switch (tabSelected) {
      case INFORMATION:
        return <EditInformation />;
      case INVENTORY:
        return <EditInventory />;
      case IMAGE:
        return <EditImage />;
      case VARIANT:
        return <EditVariant tabObj={tabObj} />;
      case FULFILLMENT:
        return <EditFulfillment tabObj={tabObj} />;
      case ATTACHMENT:
        return <EditAttachment tabObj={tabObj} />;
      default:
        return <EditInformation />;
    }
  };
  return (
    <>
      <Card>
        <Tabs tabs={validProductTabs} selected={selectedTabIndex} onSelect={handleTabChange} />
      </Card>
      <ProductProvider
        value={{
          handleTabChange,
          isVariant,
          isVariable,
          setBanner,
          setDescription,
          setTitle,
          productValue: value,
          refetchProduct: refetch,
        }}
      >
        <div className="productComponent">{getTab(selected)}</div>
      </ProductProvider>
    </>
  );
};

EditTabs.propTypes = tabProp.type;

export default withErrorBoundary(EditTabs);
